import React, { useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../context/SessionContext';
import AuthStep from '../components/checkout/AuthStep';

const API = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

/** Standalone sign-in/sign-up (was CheckoutModal's authOnly instance). */
export default function SignupPage() {
  const { onAuth, sessionUser } = useSession();
  const navigate = useNavigate();
  const te = false;
  const L = (en) => en;

  const [authStep, setAuthStep] = useState('form');
  const [authName, setAuthName] = useState('');
  const [authPhone, setAuthPhone] = useState('');
  const [authEmail, setAuthEmail] = useState('');
  const [consent, setConsent] = useState(true);
  const [authOtp, setAuthOtp] = useState(['', '', '', '', '', '']);
  const [normPhone, setNormPhone] = useState('');
  const [authLoading, setAuthLoading] = useState(false);
  const [authError, setAuthError] = useState('');
  const [resendLeft, setResendLeft] = useState(0);
  const otpRefs = useRef([]);

  if (sessionUser) { navigate('/profile', { replace: true }); return null; }

  const handleSendOtp = async () => {
    setAuthError('');
    const digits = authPhone.replace(/\D/g, '');
    if (!authName.trim()) { setAuthError('Please enter your name'); return; }
    if (digits.length < 10) { setAuthError('Enter a valid 10-digit mobile number'); return; }
    setAuthLoading(true);
    try {
      const refCode = (() => { try { return sessionStorage.getItem('nrk_ref') || ''; } catch { return ''; } })();
      const res = await axios.post(`${API}/api/auth/send-otp`, { phone: digits, name: authName.trim(), email: authEmail.trim(), referral_code: refCode || undefined });
      setNormPhone(res.data.phone);
      if (res.data.otp_required === false) { await finishSignup(res.data.phone); return; }
      setAuthStep('otp'); setResendLeft(30);
      setTimeout(() => otpRefs.current[0]?.focus(), 150);
    } catch (err) {
      setAuthError(err.response?.data?.error || 'Failed to send OTP. Try again.');
    } finally { setAuthLoading(false); }
  };

  const finishSignup = async (normalizedPhone) => {
    try {
      const res = await axios.post(`${API}/api/auth/verify-otp`, { phone: normalizedPhone, otp: '000000', name: authName.trim(), email: authEmail.trim() });
      const loggedUser = { ...(res.data.user || {}), token: res.data.token };
      try { sessionStorage.removeItem('nrk_ref'); } catch { /* ignore */ }
      onAuth(loggedUser);
      navigate('/profile');
    } catch (err) {
      setAuthError(err.response?.data?.error || 'Signup failed. Try again.');
    } finally { setAuthLoading(false); }
  };

  const handleOtpChange = (i, val) => {
    const d = val.replace(/\D/g, '').slice(-1);
    const next = [...authOtp]; next[i] = d; setAuthOtp(next);
    if (d && i < 5) setTimeout(() => otpRefs.current[i + 1]?.focus(), 0);
    if (d && next.every((x) => x)) handleVerifyOtp(next.join(''));
  };

  const handleOtpKey = (i, e) => { if (e.key === 'Backspace' && !authOtp[i] && i > 0) otpRefs.current[i - 1]?.focus(); };

  const handleVerifyOtp = async (code) => {
    const otpStr = code || authOtp.join('');
    if (otpStr.length < 6) { setAuthError('Enter all 6 digits'); return; }
    setAuthError(''); setAuthLoading(true);
    try {
      const res = await axios.post(`${API}/api/auth/verify-otp`, { phone: normPhone, otp: otpStr, name: authName.trim(), email: authEmail.trim() });
      const loggedUser = { ...(res.data.user || {}), token: res.data.token };
      try { sessionStorage.removeItem('nrk_ref'); } catch { /* ignore */ }
      onAuth(loggedUser);
      navigate('/profile');
    } catch (err) {
      setAuthError(err.response?.data?.error || 'Invalid OTP. Try again.');
      setAuthOtp(['', '', '', '', '', '']);
      setTimeout(() => otpRefs.current[0]?.focus(), 0);
    } finally { setAuthLoading(false); }
  };

  const handleResend = async () => {
    if (resendLeft > 0) return;
    setAuthError(''); setAuthOtp(['', '', '', '', '', '']); setAuthLoading(true);
    try {
      await axios.post(`${API}/api/auth/send-otp`, { phone: normPhone, name: authName.trim(), email: authEmail.trim() });
      setResendLeft(30);
      setTimeout(() => otpRefs.current[0]?.focus(), 150);
    } catch (err) { setAuthError(err.response?.data?.error || 'Failed to resend.'); }
    finally { setAuthLoading(false); }
  };

  return (
    <div className="max-w-lg mx-auto px-4 md:px-6 py-8 md:py-14">
      <AuthStep
        authStep={authStep} authName={authName} setAuthName={setAuthName}
        authPhone={authPhone} setAuthPhone={setAuthPhone}
        authEmail={authEmail} setAuthEmail={setAuthEmail}
        consent={consent} setConsent={setConsent}
        authOtp={authOtp} otpRefs={otpRefs} normPhone={normPhone}
        authLoading={authLoading} authError={authError} resendLeft={resendLeft}
        upiSettings={{ otp_required: true }} cart={[]} total={0} te={te} L={L}
        handleSendOtp={handleSendOtp} handleOtpChange={handleOtpChange}
        handleOtpKey={handleOtpKey} handleVerifyOtp={handleVerifyOtp}
        handleResend={handleResend} onClose={() => navigate('/')} authOnly
        onChangeNumber={() => { setAuthStep('form'); setAuthOtp(['', '', '', '', '', '']); }}
      />
    </div>
  );
}
